export type WithSubComponents<T, S> = T & S;

export type Prettify<T> = {
    [K in keyof T]: T[K];
    // eslint-disable-next-line @typescript-eslint/ban-types
} & {};

export const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);

export const toPascalCase = (s: string) =>
    s.charAt(0).toUpperCase() + s.slice(1);
